export const INSTANCE_DELETED = 'Instance was deleted'
export const UNSUPPORTED_VECTOR_TYPE = 'Unsupported vector type'
export const UNSUPPORTED_BITSIZES_TYPE =
  'Unsupported argument type! `bitSizes` must be an Int32Array'
export const UNSUPPORTED_BATCH_ENCODE_ARRAY_TYPE =
  'Unsupported array type! `array` must be of type Int32Array, Uint32Array, BigInt64Array, or BigUint64Array.'
export const UNSUPPORTED_CKKS_ENCODE_ARRAY_TYPE =
  'Unsupported array type! `array` must be of type Float64Array.'
export const INVALID_PLAIN_CONSRUCTOR_OPTIONS =
  'Must specify a (coeffCount), (coeffCount, capacity)'
export const INVALID_CIPHER_CONSTRUCTOR_OPTIONS =
  'Must specify a (context), (context, parmsId), or (context, parmsId, sizeCapacity)'
